export const locale = {
  lang: 'en',
  data: {
    'TOOLBAR': {
      'MENU': {
        'PROFILE': 'My Profile',
        'LOGOUT': 'Logout'
      },
    }
  }
};
